import { Box, Button, Card, Stack, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";
import { ReactComponent as FileIcon } from "./../../../../../assets/file.svg";

export const DownloadTemplateFiles = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const files = [
    "CSV File",
    "Excel File",
    "JSON File",
  ];

  return (
    <Stack spacing={2} sx={{ width: "100%", height: 300, padding: "1.3rem" }}>
      {files.map((file, index: number) => {
        return (
          <Card
            elevation={0}
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "1rem",
              backgroundColor: colors.primary[800],
              borderRadius: ".8rem",
            }}
          >
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
              <FileIcon style={{ width: "20px", height: "20px" }} />
              <Typography variant="body2">{file}</Typography>
            </Box>

            <Box>
              <Button variant="contained">Download</Button>
              <Button variant="text">View</Button>
            </Box>
          </Card>
        );
      })}
    </Stack>
  );
};
